import { useMemo } from "react";
import type {
  ModelType,
  ModelWithIsCompatibleAndTags,
} from "../../../types.ts";

export const useModelPickerFilteredModels = (
  modelType: ModelType,
  models: ModelWithIsCompatibleAndTags[],
) =>
  useMemo(
    () =>
      models.filter(
        (model: ModelWithIsCompatibleAndTags) =>
          ["TRAINING", "READY"].includes(model.status) &&
          model.type === modelType,
      ),
    [models, modelType],
  );
